import React from "react";

const DoubleColumn = ({ title, description, img, position, clrClass }) => {
  return (
    <div
      className={`w-full ${clrClass} rounded-lg px-4 sm:px-6 md:px-10 lg:px-20 py-8 sm:py-12 md:py-16 lg:py-20`}
      id="about-us"
    >
      {/* Content Section */}
      <div
        className={`flex flex-col lg:flex-row items-start lg:space-x-10 xl:space-x-20 gap-6 md:gap-8 ${
          position === "left" ? "" : "lg:flex-row-reverse"
        }`}
      >
        {/* Image Section */}
        <div className="w-full lg:w-1/2">
          <div
            className={`font-Poppins font-extrabold text-3xl sm:text-4xl md:text-5xl mb-4 md:mb-6 invisible ${
              position === "left" ? "text-left" : "text-left"
            }`}
          >
            {title}
          </div>
          <img
            src={img}
            alt={title}
            className="rounded-lg w-full h-auto object-cover"
          />
        </div>

        {/* Text Section */}
        <div className="w-full lg:w-1/2 mt-6 lg:mt-0">
          {/* Title */}
          <div
            className={`font-Poppins font-extrabold text-3xl sm:text-4xl md:text-5xl mb-4 md:mb-6 ${
              position === "left" ? "text-left" : "text-left"
            }`}
          >
            {title}
          </div>
          {/* Description */}
          <ul
            className={`list-disc ${
              position === "left" ? "pl-4 sm:pl-6" : "lg:pr-4 xl:pr-6"
            } font-Poppins text-sm sm:text-base md:text-lg lg:text-xl leading-6 sm:leading-7 lg:leading-8 space-y-3 md:space-y-4`}
          >
            {description.map((item, index) => (
              <li key={index} className="text-gray-700">{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DoubleColumn;